<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/label/wo/report/record/page" getKey="rows" :columns="columns">

    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_production_management_work_report_label_barcode",
  data() {
    return {
      columns:[
        {label: 'biaoqiantiaomahao',prop: 'printRecord.labelBarcodeNumber' },
        {label: 'baozhuangshuliang',prop: 'printRecord.packageNumber'},
        {label: 'yibaogongliangpinshu',prop: 'goodQuantity' },
        {label: 'picihao',prop: 'printRecord.batchNo' },
        {label: 'chuangjianren',prop: 'createByObject.nickname', width: 130 },
        {label: 'chuangjianshijian', prop: 'createTime', type: 'time', width: 170 }
      ],
    }
  },
  created(){
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        reportRecordId: this.$attrs.reportRecord.id,
      };
      this.yt.get(1);
    }, 300);
  },
  methods:{

  },
}
</script>

<style scoped>

</style>